import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

// Fix Element UI aria-hidden focus conflict warning
document.addEventListener('focusin', (e) => {
  const el = e.target
  if (el && el.classList && el.classList.contains('el-radio__original')) {
    el.removeAttribute('aria-hidden')
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')